import './AllDocumentDialog.style.less'

import { Modal, Tree } from 'antd'
import { AxiosResponse } from 'axios'
import { useQuery } from 'react-query'

/* eslint-disable security/detect-non-literal-fs-filename */
import { useEffect } from 'react'
import { orderBy } from 'lodash'
import cx from 'classnames'
import { useAtom } from 'jotai'
import { themeAtom } from '@/jotai/theme.jotai'
import { isDark } from '@/utils/darkmode'
import HttpRequest from '@/config/axios.config'
import { getUrlParams } from '@/utils/common'

const { DirectoryTree } = Tree

interface Prop {
  visible: boolean
  onClose: () => any
}

function AllDocumentDialog(prop: Prop) {
  const { visible, onClose } = prop

  const endpoint = '/documents/orders/'
  const [theme] = useAtom(themeAtom)

  const orderId = getUrlParams('orderKey')

  const { data, refetch } = useQuery('doc', () =>
    HttpRequest.get(`${endpoint}${orderId}`)
  )

  useEffect(() => {
    if (visible) refetch()
  }, [visible])

  const _getTreeData = (data: AxiosResponse<any, any>) => {
    return data && data?.data && data.data?.data
      ? data.data?.data.map((item) => {
          return {
            title: item?.name ?? '',
            key: item?.id ?? '',
            children: item?.tasks
              ? orderBy(item?.tasks, ['display_order'], ['asc']).map(
                  (subitem) => {
                    return {
                      title: subitem?.name ?? '',
                      key: subitem?.id ?? '',
                      children: subitem?.medias
                        ? subitem.medias.map((leaf) => {
                            return {
                              title: leaf?.medias_name ?? '',
                              key: leaf?.medias_id ?? '',
                              url: leaf?.medias_url_path ?? '',
                              isLeaf: true,
                              children: null,
                            }
                          })
                        : [],
                    }
                  }
                )
              : [],
          }
        })
      : []
  }

  return (
    <>
      {visible && (
        <Modal
          title={<div className="dialog-header py-2">Files Archive</div>}
          visible={visible}
          width={600}
          onCancel={() => onClose()}
          footer={null}
          className={cx(isDark(theme) && 'dark-file-modal')}
        >
          <DirectoryTree
            onSelect={(e, info: any) => {
              if (info?.node?.isLeaf) window.open(info?.node?.url, '_blank')
            }}
            defaultExpandAll={false}
            showIcon={true}
            treeData={_getTreeData(data)}
          />
        </Modal>
      )}
    </>
  )
}

export default AllDocumentDialog
